const ITEMS = [
    "ENGULF SUMMIT 2026",
    "31 OKTOBER 2026",
    "CONNEXION BANGSAR KUALA LUMPUR",
    "FREE ENTRY",
    "LIMITED 100 PAX",
    "QOD & CIKGU IRFAN",
];

const Row = ({ hidden = false }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center">
                <span
                    className={`whitespace-nowrap px-7 font-display text-2xl font-extrabold uppercase tracking-tight md:text-4xl ${
                        i % 2 ? "text-outline-chrome opacity-70" : "text-white/25"
                    }`}
                >
                    {t}
                </span>
                <span
                    className={`h-2 w-2 rotate-45 ${i % 2 ? "bg-volt/80" : "bg-blood/80"}`}
                />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <section
        data-testid="marquee-section"
        className="mt-16 overflow-hidden border-y border-white/5 bg-white/[0.02] py-6 md:mt-24 md:py-8"
    >
        <div className="marquee-track flex w-max">
            <Row />
            <Row hidden />
        </div>
    </section>
);

export default Marquee;
